import React from 'react';

import svg from './assets/icons-16-email.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconEmail = (props: IconProps) => <SvgIcon {...props} src={svg} testId="icon-email" />;
